import { apiInterceptor } from 'utils/apiInterceptor';
/**
 * invites users for the leads app
 * @param {object} data data required invite users to leads app
 */
export async function inviteUsers(data, projectId) {
    const response = await apiInterceptor(
        `${process.env.REACT_APP_MYXP_API_V2}/sponsor/leads?projectId=${projectId}`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        }
    );
    return await response.json();
}
